<template>
	<div class="catalog-search">
			<input type="text" v-model="keyword" @keydown.enter.prevent="search" placeholder="商品検索">
      <button type="button" @click.prevent="search"><i class="fas fa-search"></i></button>
	</div>
</template>

<script>
  export default {
    data: function () {
      return {
        keyword: ""
      }
    },
    methods: {
      search: function () {
        var key = (this.keyword || '').trim()
        if (!key) {
          this.$router.push({path: "/"})
          return
        }
        this.$router.push({path: "/search/" + encodeURIComponent(key)});      
      }
    }
  }  
</script>
